module.exports = "/assets/js/524a82a8b095908b03a35d1afcafcd49.svg";